import { useState } from "react";
import { GerarModalConfirmacao } from "../../../../components/PopUpConfirmacao";
import { TextoAdicionar } from "../styles";
import formatarReal from "../../../../utils/formatarReal";
import {
  BotaoVerdePreenchido,
  BotaoVermelhoVazado,
} from "../../../../components/Botao";
import { CampoDeInputNumericoComSetas } from "../../../../components/CampoInput";

export default function ModalAdicionar({ item, adicionarExtra }) {
  const [quantidade, setQuantidade] = useState(0);

  function garantirValor(value) {
    return value ? value : 0;
  }
  return (
    <GerarModalConfirmacao
      trigger={
        <TextoAdicionar
          style={{
            cursor: "pointer",
          }}
        >
          Adicionar
        </TextoAdicionar>
      }
      titulo={`Adicionar quantidade ${item?.nomeItemDescricao ?? ""}`}
      subTitulo={
        <div style={{ marginLeft: 0, marginTop: "-26px" }}>
          <p style={{ fontSize: 18, lineHeight: "normal", marginBottom: 24 }}>
            A quantidade definida a seguir será somada a quantidade atual.
          </p>
          <p style={{ fontSize: 18, lineHeight: "normal", marginBottom: 24 }}>
            Valor Unitário:
            <span
              style={{
                marginLeft: 4,
              }}
            >
              {formatarReal(item.valorUnitario)}
            </span>
          </p>
          <p style={{ fontSize: 18, lineHeight: "normal", marginBottom: 24 }}>
            Quantidade já contratada:
            <span
              style={{
                marginLeft: 4,
              }}
            >
              {garantirValor(item.quantidadeContratada) -
                garantirValor(item.quantidadeRecorrenciaCancelada)}
            </span>
          </p>
        </div>
      }
      botaoCancelar={(fechar) => (
        <BotaoVermelhoVazado
          texto="Cancelar"
          tamanho="MD"
          onClick={fechar}
          style={{
            minWidth: "150px",
            padding: "0px 0px",
            userSelect: "none",
          }}
        />
      )}
      botaoConfirmar={(fechar) => (
        <BotaoVerdePreenchido
          style={{
            minWidth: "150px",
            padding: "0px 0px",
            userSelect: "none",
          }}
          texto="Adicionar"
          tamanho="MD"
          onClick={() => {
            adicionarExtra(item.idItemConfiguracao, quantidade);
          }}
        />
      )}
      campoInput={
        <CampoDeInputNumericoComSetas
          width="100%"
          label="Quantidade"
          style={{ userSelect: "none" }}
          value={quantidade}
          onChange={(e) => {
            setQuantidade(e);
          }}
        />
      }
    />
  );
}
